import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import { useState, useEffect } from 'react';
import Container from '@mui/material/Container';
import { useLocation } from 'react-router-dom';
import { GetSessionContext } from '../../data/apiCalls';
import { idleTracker } from '../../scripts/idleTracker';
import useSessionContext from '../../data/queryHooks/useSessionContext';
import { LOGOUT_URL, HOME_URL } from '../../scripts/navigationItems';
import CustomLoading from '../../components/shared/CustomLoading';
import useManageDefaultLocation from '../../hooks/useManageDefaultLocation';
import ProtectedRoute from './ProtectedRoute/ProtectedRoute';
import Header from './Header/Header';
import Footer from './Footer/Footer';
import IdleModal from './Modal/IdleModal';

const RootLayout = styled('div')`
	display: grid;
	grid-template-columns: minmax(0, 1fr);
	grid-template-rows: auto 1fr auto;
	grid-template-areas:
		'header'
		'main'
		'footer';
	min-height: 100vh;

	.header {
		grid-area: header;
	}

	.main {
		grid-area: main;
	}

	.footer {
		grid-area: footer;
	}
`;

const Layout = () => {
	const { isLoading, isLoggedIn } = useSessionContext();
	const { hasDefaultLocation, setHasDefaultLocation } =
		useManageDefaultLocation();
	const location = useLocation();
	const [modalOpen, setModalOpen] = useState(false);
	const [staySingedIn, setStaySignedIn] = useState(false);

	const openModal = () => {
		setModalOpen(true);
	};

	const checkSession = async () => {
		try {
			const res = await GetSessionContext();
			if (res?.resultCode !== 0)
				window.open(LOGOUT_URL, '_self', 'noreferrer');
		} catch (error) {
			return error;
		}
		return null;
	};
	useEffect(() => {
		checkSession();
	}, [location.pathname]);
	useEffect(() => {
		if (staySingedIn) {
			setModalOpen(false);
			idleTracker(isLoggedIn, openModal);
			setStaySignedIn(false);
		}
	}, [staySingedIn]);

	useEffect(() => {
		idleTracker(isLoggedIn, openModal);
	}, [isLoggedIn]);

	if (isLoading) {
		return (
			<Container sx={{ mt: 7 }}>
				<CustomLoading />
			</Container>
		);
	}

	if (!isLoggedIn) {
		window.open(HOME_URL, '_self', 'noreferrer');
		return (
			<Container sx={{ mt: 7 }}>
				<CustomLoading />
			</Container>
		);
	}

	return (
		<RootLayout>
			<Header
				className='header'
				hasDefaultLocation={hasDefaultLocation}
			/>
			<IdleModal
				open={modalOpen}
				setSignedIn={() => setStaySignedIn(true)}
			/>
			<Box className='main' component='main' sx={{ mb: 5 }}>
				<ProtectedRoute
					hasDefaultLocation={hasDefaultLocation}
					setHasDefaultLocation={setHasDefaultLocation}
				/>
			</Box>
			<Footer
				className='footer'
				hasDefaultLocation={hasDefaultLocation}
			/>
		</RootLayout>
	);
};

export default Layout;
